import {
  ButtonArrowState,
  PrimaryButton,
  TertiaryButton,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CardDetailsModal from './CardDetailsModal';
import ReportMisuseModal from './ReportMisuseModal';
import styles from './prepaidCard.module.scss';

const Actions = ({
  cardTitle,
  sensitiveCardData,
  fetchSensitiveCardData,
  fetchSensitiveCardDataError,
  isFetchingSensitiveCardData,
  reportMisuse,
  reportMisuseError,
  isReportingMisuse,
}) => {
  const [showCardDetailsModal, setShowCardDetailsModal] = useState(false);
  const [showReportMisuseModal, setShowReportMisuseModal] = useState(false);

  const onSeeCardDetailsClick = () => {
    if (!sensitiveCardData) {
      fetchSensitiveCardData();
    }

    setShowCardDetailsModal(true);
  };

  const onReportAsLostOrStolenClick = () => {
    setShowReportMisuseModal(true);
  };

  return (
    <>
      <div className={styles.actionsContainer}>
        <PrimaryButton
          label={dictionary.prepaidCards.labels.seeCardDetails}
          onClick={onSeeCardDetailsClick}
          arrow={ButtonArrowState.None}
        />
        <TertiaryButton
          label={dictionary.prepaidCards.labels.reportMisuse}
          onClick={onReportAsLostOrStolenClick}
          arrow={ButtonArrowState.None}
        />
      </div>
      {showCardDetailsModal && (
        <CardDetailsModal
          title="CARD DETAILS"
          sensitiveCardData={sensitiveCardData}
          error={fetchSensitiveCardDataError}
          isLoading={isFetchingSensitiveCardData}
          onClose={() => setShowCardDetailsModal(false)}
        />
      )}
      {showReportMisuseModal && (
        <ReportMisuseModal
          error={reportMisuseError}
          isLoading={isReportingMisuse}
          reportMisuse={reportMisuse}
          onClose={() => setShowReportMisuseModal(false)}
        />
      )}
    </>
  );
};

Actions.propTypes = {
  cardTitle: PropTypes.string.isRequired,
  sensitiveCardData: PropTypes.object,
  isFetchingSensitiveCardData: PropTypes.bool.isRequired,
  fetchSensitiveCardDataError: PropTypes.object,
  fetchSensitiveCardData: PropTypes.func.isRequired,
  reportMisuse: PropTypes.func.isRequired,
  isReportingMisuse: PropTypes.bool.isRequired,
  reportMisuseError: PropTypes.object,
};

export default Actions;
